import { cn } from "@flare/ui";

export const PAGINATION_CONTAINER_CLASS_NAME = "swiper-pagination-custom";

export function PaginationContainer() {
  return (
    <div
      className={cn(
        PAGINATION_CONTAINER_CLASS_NAME,
        "mt-sp-6 text-center [&_.swiper-pagination-bullet]:w-[6px] [&_.swiper-pagination-bullet]:h-[6px] [&_.swiper-pagination-bullet]:m-r-[1px] [&_.swiper-pagination-bullet-active]:w-[16px] [&_.swiper-pagination-bullet-active]:b-r-[16px] [&_.swiper-pagination-bullet-active]:!bg-spectrum-evergreen",
      )}
    ></div>
  );
}
